<template>
  <v-combobox
    label="Interests"
    v-model="profile.interests"
    :color="themes.candidate.light.input"
    :loading="loading"
    append-icon=""
    :items="[]"
    @blur="submit"
    multiple
    chips
  >
    <template slot="selection" slot-scope="{ item, selected, parent }">
      <v-chip
        @input="parent.onChipInput"
        :color="themes.candidate.light.chip"
        :selected="selected"
        :key="`interest-${item}`"
      >
        {{ item }}
        <v-icon right :color="themes.candidate.light.cancel" @click="parent.selectItem(item)">
          mdi-close-circle
        </v-icon>
      </v-chip>
    </template>
  </v-combobox>
</template>

<script>
// Vue Component
export default {
  props: {
    value: Array,
  },
  data() {
    return {
      // Loading indicator
      loading: false,
      // Model (object sent to API)
      profile: {
        interests: this.value || [],
      },
    }
  },
  methods: {
    submit() {
      if (this.value !== this.profile.interests) {
        this.loading = true
        this.$store
          .dispatch('candidate/profile/update', this.profile)
          .then(() => (this.loading = false))
      }
    },
  },
}
</script>
